import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Função Original de Sala',
  path: '/gestao/funcaooriginalsala',
  name: 'funcaooriginalsala',
  component: () => import('@/views/gestao/funcaooriginalsala/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.FUNCAOORIGINALDASALANOVO_MENU_300900193],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Função Original de Sala',
  path: '/gestao/funcaooriginalsala/cadastro/:id?',
  parent: 'funcaooriginalsala',
  name: 'funcaooriginalsala_create',
  component: () => import('@/views/gestao/funcaooriginalsala/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.FUNCAOORIGINALDASALANOVO_MENU_300900193],
  },
  goesToMenu: true,
 },
]
